import PdImage from '@/components/pd-image/pd-image'
import { useRouter } from 'next/router'
import Image from 'next/image'
interface ProductCardProps {
  img: string
  name: string
  jumpUrl: string
}
const ProductCard = ({ img, name, jumpUrl }: ProductCardProps) => {
  const router = useRouter()
  return (
    <div className="w-full flex flex-col cursor-pointer bg-gray-100" onClick={() => router.push(jumpUrl)}>
      <div className="w-full h-55 laptop:h-110">
        <PdImage src={img} enableMask={false} object="contain" width={'100%'} height={'100%'} />
      </div>
      <div className="self-stretch p-6 bg-blue-600 inline-flex justify-between items-center">
        <div className="w-44 flex justify-start items-center gap-6">
          <div className="justify-center text-white text-base font-semibold leading-normal">{name}</div>
        </div>
        <Image src="/icons/icon_indicator_white.svg" alt={name} width={24} height={24} />
      </div>
    </div>
  )
}

export default ProductCard
